const data = [
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "16A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU3P-16A",
    "price": "8260"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "20A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU3P-20A",
    "price": "8260"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "25A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU3P-25A",
    "price": "8260"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "32A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU3P-32A",
    "price": "8260"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "40A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU3P-40A",
    "price": "8260"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "50A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU3P-50A",
    "price": "8260"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "16A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU4P-16A",
    "price": "10620"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "20A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU4P-20A",
    "price": "10620"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "25A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU4P-25A",
    "price": "10620"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "32A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU4P-32A",
    "price": "10620"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "40A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU4P-40A",
    "price": "10620"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "50A",
    "breaking_capacity": "25kA",
    "catalogue_number": "CSE1M125FMU4P-50A",
    "price": "10620"
  },

  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "16A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU3P-16A",
    "price": "10600"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "20A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU3P-20A",
    "price": "10600"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "25A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU3P-25A",
    "price": "10600"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "32A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU3P-32A",
    "price": "10600"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "40A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU3P-40A",
    "price": "10600"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "3P",
    "rating": "50A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU3P-50A",
    "price": "10600"
  },

  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "16A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU4P-16A",
    "price": "12920"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "20A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU4P-20A",
    "price": "12920"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "25A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU4P-25A",
    "price": "12920"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "32A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU4P-32A",
    "price": "12920"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "40A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU4P-40A",
    "price": "12920"
  },
  {
    "component": "MCCB",
    "make": "C&S",
    "type": "WiNbreak1 MCCB",
    "release": "FMU (Thermal Magnetic) Release | Adjustable Overload 80-100% | Fixed short circuit",
    "frame": "Frame 1",
    "poles": "4P",
    "rating": "50A",
    "breaking_capacity": "36kA",
    "catalogue_number": "CSE1NN125FMU4P-50A",
    "price": "12920"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ4-250N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "160A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ4T0160NXF1A0O00",
    "price": "46300"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ4-250N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "160A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ4F0160NXF1A0O00",
    "price": "59200"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ4-250N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "250A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ4T0250NXF1A0O00",
    "price": "47700"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ4-250N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "250A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ4F0250NXF1A0O00",
    "price": "60500"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ6-400N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "250A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ6T0250NXF1A0O00",
    "price": "51800"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ6-400N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "250A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ6F0250NXF1A0O00",
    "price": "67500"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ6-400N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "400A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ6T0400NXF1A0O00",
    "price": "54500"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ6-400N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "400A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ6F0400NXF1A0O00",
    "price": "71000"
  },

  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800N / DZ7-1000N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "630A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ7T0630NXF1A0O00",
    "price": "64000"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800N / DZ7-1000N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "630A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ7F0630NXF1A0O00",
    "price": "78000"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800N / DZ7-1000N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "800A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ7T0800NXF1A0O00",
    "price": "89900"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800N / DZ7-1000N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "800A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ7F0800NXF1A0O00",
    "price": "114400"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800N / DZ7-1000N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "1000A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ7T1000NXF1A0O00",
    "price": "154100"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800N / DZ7-1000N",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "1000A",
    "breaking_capacity": "50kA",
    "catalogue_number": "DZ7F1000NXF1A0O00",
    "price": "213700"
  },

  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ2-160H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "40A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ2T0040HXF1A0O00",
    "price": "37000"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ2-160H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "40A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ2F0040HXF1A0O00",
    "price": "46100"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ2-160H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "63A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ2T0063HXF1A0O00",
    "price": "37000"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ2-160H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "63A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ2F0063HXF1A0O00",
    "price": "46100"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ2-160H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "100A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ2T0100HXF1A0O00",
    "price": "37000"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ2-160H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "100A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ2F0100HXF1A0O00",
    "price": "46100"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ2-160H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "160A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ2T0160HXF1A0O00",
    "price": "48400"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ2-160H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "160A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ2F0160HXF1A0O00",
    "price": "60600"
  },

  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ4-250H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "160A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ4T0160HXF1A0O00",
    "price": "51000"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ4-250H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "160A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ4F0160HXF1A0O00",
    "price": "63900"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ4-250H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "250A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ4T0250HXF1A0O00",
    "price": "57200"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ4-250H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "250A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ4F0250HXF1A0O00",
    "price": "78700"
  },

  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ6-400H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "250A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ6T0250HXF1A0O00",
    "price": "66800"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ6-400H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "250A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ6F0250HXF1A0O00",
    "price": "88200"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ6-400H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "400A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ6T0400HXF1A0O00",
    "price": "70300"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ6-400H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "400A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ6F0400HXF1A0O00",
    "price": "92800"
  },

  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800H / DZ7-1000H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "630A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ7T0630HXF1A0O00",
    "price": "74900"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800H / DZ7-1000H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "630A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ7F0630HXF1A0O00",
    "price": "109000"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800H / DZ7-1000H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "800A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ7T0800HXF1A0O00",
    "price": "106000"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800H / DZ7-1000H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "800A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ7F0800HXF1A0O00",
    "price": "138600"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800H / DZ7-1000H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "3P",
    "rating": "1000A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ7T1000HXF1A0O00",
    "price": "173900"
  },
  {
    "component": "MCCB",
    "make": "L&T",
    "type": "DZ7-800H / DZ7-1000H",
    "release": "DZ MCCB with Microprocessor Release iTRP1",
    "poles": "4P",
    "rating": "1000A",
    "breaking_capacity": "80kA",
    "catalogue_number": "DZ7F1000HXF1A0O00",
    "price": "251600"
  }
]

export default data;


